import OfferInterface from 'interfaces/offer.interface';
import { SortType } from '../reducers/offers';

export function offersSort(selectedSort: SortType): (prev: OfferInterface, next: OfferInterface) => number {
    if (selectedSort === SortType.BestOffer) {
        return (prev: OfferInterface, next: OfferInterface): number => {
            if (next.score !== prev.score) {
                return next.score - prev.score;
            }

            return Number(prev.dealer.outOfLimit) - Number(next.dealer.outOfLimit);
        };
    }

    if (selectedSort === SortType.PriceAsc) {
        return (prev: OfferInterface, next: OfferInterface): number => {
            if (prev.price !== next.price) {
                return prev.price - next.price;
            }

            return Number(prev.dealer.outOfLimit) - Number(next.dealer.outOfLimit);
        };
    }

    if (selectedSort === SortType.PriceDesc) {
        return (prev: OfferInterface, next: OfferInterface): number => {
            if (next.price !== prev.price) {
                return next.price - prev.price;
            }

            return Number(prev.dealer.outOfLimit) - Number(next.dealer.outOfLimit);
        };
    }

    if (selectedSort === SortType.ShopScore) {
        return (prev: OfferInterface, next: OfferInterface): number => {
            if (!prev.dealer.opinions) {
                return 1;
            }

            if (!next.dealer.opinions) {
                return -1;
            }

            return next.dealer.opinions?.average - prev.dealer.opinions?.average;
        };
    }

    return (): number => 0;
}
